import axiosInstance from "../api/axiosInstance";

export const fetchGuestLists = (params) =>
  axiosInstance.get("/admin/guestList", { params });

export const getGuestListDetail = (id) =>
  axiosInstance.get(`/admin/guestListDetail/${id}`);
